import { render, staticRenderFns } from "./hc.vue?vue&type=template&id=97b85b46"
import script from "./hc.vue?vue&type=script&lang=js"
export * from "./hc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports